import { createSlice } from "@reduxjs/toolkit";

// initial form 
export const initialInventoryForm={
    title : "",
    price_per_unit : "",
    quantity : 1,
    date : "",
    product_id: "",
    vendor_id: "",
    logo:""
}

const inventorySlice = createSlice({
    name:"inventorySlice",
    initialState:{
        form:{
            addNewInventory:initialInventoryForm,
            searchInventory: {
                title : "",
            }
        },
        popup:{
            addInventoryPopup:false,
            editInventoryPopup:false,
            deleteInventoryPopup:false,
        }
    },
    reducers:{
        addNewInventory:(state, action)=>{
            state.form.addNewInventory=action.payload
        },
        searchInventory:(state, action)=>{
          state.form.searchInventory=action.payload  
        },
        openAddInventoryPopup:(state)=>{
            state.popup.addInventoryPopup=true
        },
        closeAddInventoryPopup:(state)=>{
            state.popup.addInventoryPopup=false
        },
        openEditInventoryPopup:(state)=>{
            state.popup.editInventoryPopup=true
        },
        closeEditInventoryPopup:(state)=>{
            state.popup.editInventoryPopup=false
        },
        openDeleteInventoryPopup:(state)=>{
            state.popup.deleteInventoryPopup=true
        },
        closeDeleteInventoryPopup:(state)=>{
            state.popup.deleteInventoryPopup=false
        }
    }
})

export const {addNewInventory,searchInventory, openAddInventoryPopup, closeAddInventoryPopup,
openEditInventoryPopup, closeEditInventoryPopup,
openDeleteInventoryPopup, closeDeleteInventoryPopup}=inventorySlice.actions

export const getAddInventoryPopup=(state)=>state.inventory.popup.addInventoryPopup
export const getEditInventoryPopup=(state)=>state.inventory.popup.editInventoryPopup
export const getDeleteInventoryPopup=(state)=>state.inventory.popup.deleteInventoryPopup
export const getAddNewInventory=(state)=>state.inventory.form.addNewInventory
export const getSearchInventory=(state)=>state.inventory.form.searchInventory

export default inventorySlice.reducer